(function () {
  async function addItemToCart(e) {
    e.target.disabled = true;
    const variantId = e.target.dataset.variantId;

    const payload = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };

    if (e.target.dataset.sellingPlanId) {
      payload.items[0]['selling_plan'] = e.target.dataset.sellingPlanId;
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });
      await res.json();
      Shopify.openCartDrawer();
      e.target.disabled = false;
    } catch (err) {
      console.log(err);
      e.target.disabled = false;
    }
  }

  window.addEventListener('load', function () {
    const addToCartButtons = document.querySelectorAll('.collection__atc');

    addToCartButtons.forEach(function (btn) {
      btn.addEventListener('click', addItemToCart);
    });

    const ratings = document.querySelectorAll(
      '[data-oke-reviews-product-listing-rating]'
    );

    if (!ratings.length) {
      return;
    }

    ratings.forEach(function (rating) {
      if (rating.children.length) {
        for (let child of rating.children) {
          if (child.textContent.trim() == '') {
            rating.style.display = 'none';
          }
        }
      }
    });
  });

  // Add UTM params to product links in collections with '-paid' in the URL
  window.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('section.js-collection-paid')) {
      const collectionGrid = document.querySelector(
        'section.js-collection-paid .collection__products'
      );
      const productCardLinks = collectionGrid?.querySelectorAll(
        '.collection__products__item a'
      );

      productCardLinks.forEach((link) => {
        const url = new URL(link.href);
        url.searchParams.set('status', 'paid');
        link.href = url.toString();
      });
    }
  });
})();
